import { render, staticRenderFns } from "./WheelBattleCreateSubMatchPopup.vue?vue&type=template&id=5f5680f8&scoped=true&"
import script from "./WheelBattleCreateSubMatchPopup.vue?vue&type=script&lang=js&"
export * from "./WheelBattleCreateSubMatchPopup.vue?vue&type=script&lang=js&"
import style0 from "./WheelBattleCreateSubMatchPopup.vue?vue&type=style&index=0&id=5f5680f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5680f8",
  null
  
)

export default component.exports